/**
 * @description Нормализует телефон к формату E.164 для РФ: +7XXXXXXXXXX (10 национальных цифр)
 * @example
 * normalizePhone('+7 (789) 852-64-12') // "+77898526412"
 * normalizePhone('8 900 123-45-67') // "+79001234567"
 * normalizePhone('9001234567') // "+79001234567"
 * normalizePhone('+380501234567') // "+380501234567" (иные страны — без преобразования к +7)
 */
export const normalizePhone = (raw: string): string => {
  const input = (raw ?? '').trim();
  if (input === '') return '';

  const digits = input.replace(/\D/g, '');

  // Уже E.164 РФ (+7...)
  if (input.startsWith('+7')) {
    // Берём последние 10 цифр как национальный номер (на случай лишних символов)
    const national = digits.slice(-10);
    return national ? `+7${national}` : '+7';
  }

  // Локальные 11 цифр, начинаются на 8 -> конвертируем к +7
  if (digits.length === 11 && digits.startsWith('8')) {
    return `+7${digits.slice(1)}`;
  }

  // Локальные 11 цифр, начинаются на 7 -> считаем, что это 7 + 10
  if (digits.length === 11 && digits.startsWith('7')) {
    return `+7${digits.slice(1)}`;
  }

  // Ровно 10 цифр — считаем местным РФ номером
  if (digits.length === 10) {
    return `+7${digits}`;
  }

  // Если номер из другой страны в E.164, оставляем как есть
  if (input.startsWith('+')) {
    return `+${digits}`;
  }

  // Если больше 11 цифр и похоже на РФ, берём последние 10 как национальные
  if (digits.length > 11 && (digits.startsWith('7') || digits.startsWith('8'))) {
    return `+7${digits.slice(-10)}`;
  }

  // Фолбэк: вернуть (+) и все цифры, если ничего не подошло
  return digits ? `+${digits}` : '';
};
